export default __webpack_public_path__ + "static/media/alliance_im01.eee42072.png";